<template>
    <div class="note-container">
        <div class="ix-comments-loader" v-if="loading">
            <i class="far fa-circle-notch fa-spin"></i> Chargement des notes internes
        </div>
        <div class="slider" v-if="!loading && items.length > 0">
            <div class="slides">
                <div v-for="(item,index) in items" :key="index" :id='"slide-" + index'>
                    <div class="slide-header" >
                           <div class="slide-title" v-html="nl2br(truncate(item.title, 50))"></div>
                           <div class="slide-user"><i style="font-size: 12px !important"> Par : {{ item.user.fullname }}</i></div>
                    </div>
                 
                    <div class="slide-content">
                       <span v-if="item.content" v-html="nl2br(item.content)"></span>
                    </div>
                    <div class="slide-footer">
                        <div class="slide-footer-create">Crée le : {{ item.created_at | formatDate }}</div>
                        <div class="slide-footer-action">
                            <span @click="openModal(item)">Voir plus..</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="noteModal" tabindex="-1" aria-labelledby="noteModal" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Détail de la note</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                           <div class="col-sm-12" style="text-align: left; font-size: 18px; font-weight: bold;">{{ note.title }}</div>
                        </div>
                        <div class="row mt-4">
                           <div class="col-sm-12" v-if="note.content" style="text-align: left; font-size: 14px;" v-html="nl2br(note.content)"></div>
                        </div>
                        <div v-if="note.file && note.file != null" class="mt-2" style="text-align: left;">
                            <a :href="sourceObject.url" class="ix-link" target="_blank">Consulter le fichier</a>
                        </div>
                    </div>
                </div>
            </div>
     </div>
    </div>
</template>

<script>

export default {
    name: "Note",
   
    props: {
        url: String,
    },
    data(){
        return {
            currentIndex: 0,
            loading: false,
            items: [],
            note: [],
            sourceObject: {
                url: null,
                httpHeaders: null,
            },
        }
    },
    methods: {
        async getData(){
            this.loading = true;
            fetch(this.url, {
                ...{
                    method: 'GET'
                },
                ...this.getHttpJsonRequestHeaders(),
            }).then((response) => {
                    if (response.status == 200) {
                        response.json().then((data) => {
                            if (data) {
                                this.items = data;
                                console.log(this.items);
                            }
                        })
                    }
                    this.loading = false;
            }).catch((error) => {
                this.loading = false;
            })
        },
        openModal(item){
            this.note = item;
            this.sourceObject.url = item.file_path;
            $('#noteModal').modal();
        }
    },
    async mounted(){
       await this.getData();
    }
}
</script>

<style lang="scss">

.slider {
  width: 100%;
  text-align: center;
  overflow: hidden;
  background: #f6f8fa;
  margin-top: 20px;
}

.slides {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}
.slides::-webkit-scrollbar {
  width: 10px;
  height: 5px;
}
.slides::-webkit-scrollbar-thumb {
  background: #EAECEF;
  border-radius: 10px;
}
.slides::-webkit-scrollbar-track {
  background: transparent;
}
.slides > div {
  scroll-snap-align: start;
  flex-shrink: 0;
  width: 540px;
  height: 200px;
  margin-right: 30px;
  border-radius: 10px;
  background: white;
  transform-origin: center center;
  transform: scale(1);
  transition: transform 0.5s;
  position: relative;
  padding: 20px;
}

.author-info {
  background: rgba(0, 0, 0, 0.75);
  color: white;
  padding: 0.75rem;
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin: 0;
}
.author-info a {
  color: white;
}


.slider > a {
  display: inline-flex;
  width: 1.5rem;
  height: 1.5rem;
  background: white;
  text-decoration: none;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin: 0 0 0.5rem 0;
  position: relative;
}
.slider > a:active {
  top: 1px;
}
.slider > a:focus {
  background: #000;
}

.slide-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    text-align: left;
    color: var(--ix-text-primary);
    height: 40px;
    max-height: 40px;
}

.slide-title {
    max-width: 70%;
    font-size: 16px;
    font-weight: 500;
}

.slide-content {
    font-size: 14px;
    width: 100%;
    text-align: left;
    margin-top: 10px;
    height: 90px;
    max-height: 90px;
    overflow: hidden;
}
.slide-footer {
    display: flex;
    justify-content: space-between;
    text-align: left;
    margin-top: 10px;
    width: 100%;
}

.slide-footer-create {
    font-size: 12px;
    font-weight: 300;
}

.slide-footer-action {
    color: #3182dd;
    font-size: 14px;
    text-align: right !important;
    cursor: pointer;
}
</style>